<template>
    <IndexView />
    <Dialog v-model:visible="showErrorDialog" modal :header="'Terjadi Kesalahan'" :closable="true"
        class="w-[90vw] md:w-[50vw]">
        <div class="flex items-start space-x-3">
            <ExclamationCircleIcon class="h-6 w-6 text-red-500" />
            <p class="text-gray-700 dark:text-gray-200">{{ errorMessage }}</p>
        </div>
        <template #footer>
            <Button label="Tutup" @click="showErrorDialog = false" severity="secondary" />
        </template>
    </Dialog>
    <div id="overlay" class="fixed inset-0 bg-black bg-opacity-30 z-30" :class="{ 'hidden': !isBlur }"></div>
    <div id="table-header" class="mb-5 flex justify-between items-end">
        <div class="mb-5 flex justify-between">
            <BackButton to_url="riwayat-transaksi" button_text="Back" button_class="text-base py-2 font-medium"
                @click="toggleBlur" />
        </div>
    </div>
    <PageTitle :title="'Payment: Table ' +
        currentTable?.name +
        ' - Order #' +
        this.transaction?.code
        " />

    <div class="max-w-5xl mx-auto bg-white dark:bg-dark-900 rounded-lg shadow-md p-6 gap-5">
        <!-- Detail Transaksi -->
        <h2 class="text-xl font-semibold mb-4 text-gray-600 dark:text-gray-300 uppercase">
            Detail Transaksi
        </h2>
        <div v-for="detail in viewDetailTransaction" :key="detail.id"
            class="flex justify-between mt-4 border-gray-200 dark:border-gray-700">
            <h3 class="text-base font-semibold text-gray-600 dark:text-gray-300">
                {{ detail.field }}
            </h3>
            <p class="text-base font-semibold text-gray-800 dark:text-gray-100">
                {{ detail.type === 'rupiah' ? formatRupiah(detail.value) : detail.value }}
            </p>
        </div>

        <!-- Daftar Item -->
        <h2 class="text-xl font-semibold mb-4 text-gray-600 dark:text-gray-300 uppercase">
            Daftar Item
        </h2>
        <ListItemPayment :items="order_items" />

        <!-- Total Pembayaran -->
        <div class="flex justify-between mt-4 border-gray-200 dark:border-gray-700">
            <h3 class="text-base font-semibold text-gray-600 dark:text-gray-300">
                Sub Total
            </h3>
            <p class="text-base font-semibold text-gray-800 dark:text-gray-100">
                {{ formatRupiah(this.transaction?.total) }}
            </p>
        </div>
        <div class="flex justify-between mt-2 border-gray-200 dark:border-gray-700">
            <h3 class="text-base font-semibold text-gray-600 dark:text-gray-300">
                Discount
            </h3>
            <p class="text-base font-semibold text-gray-800 dark:text-gray-100">
                {{ formatRupiah(this.transaction?.discount) }}
            </p>
        </div>
        <div class="flex justify-between mt-2 border-gray-200 dark:border-gray-700">
            <h3 class="text-base font-semibold text-gray-600 dark:text-gray-300">
                Service Charge
            </h3>
            <p class="text-base font-semibold text-gray-800 dark:text-gray-100">
                {{ formatRupiah(this.transaction?.service_charge) }}
            </p>
        </div>
        <div class="flex justify-between mt-2 border-gray-200 dark:border-gray-700">
            <h3 class="text-base font-semibold text-gray-600 dark:text-gray-300">
                Service Tax
            </h3>
            <p class="text-base font-semibold text-gray-800 dark:text-gray-100">
                {{ formatRupiah(this.transaction?.service_tax) }}
            </p>
        </div>
        <div class="flex justify-between mt-2 border-t pt-4 border-gray-200 dark:border-gray-700">
            <h3 class="text-xl font-bold text-gray-600 dark:text-gray-300">
                Grand Total
            </h3>
            <p class="text-xl font-bold text-gray-800 dark:text-gray-100">
                {{ formatRupiah(this.transaction?.grand_total) }}
            </p>
        </div>
        <div v-if="this.transaction?.payment_amount > 0"
            class="flex justify-between mt-2 border-t pt-4 border-gray-200 dark:border-gray-700">
            <h3 class="text-base font-semibold text-gray-600 dark:text-gray-300">
                Payment
            </h3>
            <p class="text-base font-semibold text-gray-800 dark:text-gray-100">
                {{ formatRupiah(this.transaction?.payment_amount) }}
            </p>
        </div>
        <div v-if="this.transaction?.payment_change > 0"
            class="flex justify-between mt-2 pt-4 border-gray-200 dark:border-gray-700">
            <h3 class="text-base font-semibold text-gray-600 dark:text-gray-300">
                Kembalian
            </h3>
            <p class="text-base font-semibold text-gray-800 dark:text-gray-100">
                {{ formatRupiah(this.transaction?.payment_change) }}
            </p>
        </div>
    </div>
</template>

<script>
import IndexView from '@/views/IndexView.vue';
import BackButton from '@/components/buttons/BackButton.vue';
import PageTitle from '@/components/PageTitle.vue';
import ListItemPayment from '../new-transaction/payment/ListItemPayment.vue';
import { Button, Dialog } from 'primevue';
import { formatRupiah } from '@/helpers/formatRupiah';
import { mapGetters } from 'vuex';

export default {
    name: 'DetailView',
    components: {
        PageTitle, IndexView, BackButton, ListItemPayment, Dialog, Button
    },
    computed: {
        ...mapGetters("tables", ["allTables"]),
        ...mapGetters("payment_methods", ["allPaymentMethods"]),
        ...mapGetters("items", ["allItems"]),
        currentTable() {
            const id = this.transaction?.table;
            return this.allTables?.find((table) => table.id == id);
        },
        total() {
            return this.order_items?.reduce(
                (sum, item) => sum + item.price * item.quantity,
                0
            );
        },
        viewDetailTransaction() {
            if (!this.transaction) return [];
            return [
                { field: 'No. Invoice', value: this.transaction?.code || "-", type: 'text' },
                { field: 'Order Tipe', value: this.transaction?.order_type || "-", type: 'text' },
                { field: "Meja", value: this.currentTable?.name || "-", type: "text" },
                { field: 'Tanggal', value: this.formatDate(this.transaction?.createdAt), type: 'text' },
                { field: 'Nama Tamu', value: this.transaction?.customer_name || "-", type: 'text' },
                { field: 'Kasir', value: this.transaction?.cashier_name || "-", type: 'text' },
                { field: 'Marketing', value: 'Erista Dwatiga tes', type: 'text' },
                { field: 'Status', value: this.transaction?.status || "-", type: 'text' },
            ];
        }
    },
    async created() {
        try {
            // Fetch required data in parallel
            await Promise.all([
                this.$store.dispatch("tables/fetchTables", { limit: 1000 }),
                this.$store.dispatch("payment_methods/fetchPaymentMethods", { limit: 1000 }),
                this.$store.dispatch("items/fetchItems", { limit: 1000 }),
                this.checkAndRefreshOrder(),
            ]);
            this.isLoading = false;
        } catch (error) {
            console.log(error);
            this.errorMessage =
                error.message ||
                "Terjadi kesalahan saat memuat data. Silakan coba lagi.";
            this.showErrorDialog = true;
            this.isLoading = false;
        }
    },
    data() {
        return {
            isBlur: false,
            detailTransaction: [],
            order_items: [],
            showErrorDialog: false,
            errorMessage: "",
            isLoading: true,
            transaction: [],
            viewDetailTotal: [
                { field: 'Sub Total', value: 20000, type: 'rupiah' },
                { field: 'Diskon', value: 0, type: 'rupiah' },
                { field: 'Service Charge', value: 0, type: 'rupiah' },
                { field: 'Service Tax', value: 0, type: 'rupiah' },
                { field: 'Total', value: 20000, type: 'rupiah' }
            ]
        }
    },
    methods: {
        formatRupiah,
        formatDate(date) {
            if (!date) return "-";
            const d = new Date(date);
            const pad = (num) => num.toString().padStart(2, '0');

            const day = pad(d.getDate());
            const month = pad(d.getMonth() + 1);
            const year = d.getFullYear().toString().slice(-2);
            const hours = pad(d.getHours());
            const minutes = pad(d.getMinutes());

            return `${day}/${month}/${year} ${hours}:${minutes}`;
        },
        async checkAndRefreshOrder() {
            this.order_id = this.$route.query.orderId;
            if (this.order_id != null) {
                const response = await this.$store.dispatch(
                    "sales_orders/fetchSalesOrderById",
                    this.order_id
                );
                const salesOrder = response.data;
                this.transaction = {
                    id: salesOrder.id,
                    code: salesOrder.code,
                    table: salesOrder.table_id,
                    marketing_id: salesOrder.marketing_id,
                    transaction_type_id: salesOrder.transaction_type_id,
                    customer_name: salesOrder.customer_name,
                    order_type: salesOrder.order_type,
                    cashier: "Kasir 1",
                    total: salesOrder.sub_total,
                    discount: salesOrder.discount,
                    service_charge: salesOrder.service_charge,
                    service_tax: salesOrder.tax,
                    grand_total: salesOrder.grand_total,
                    status: salesOrder.status,
                    payment_amount: salesOrder.payment_amount,
                    payment_change: salesOrder.payment_change,
                    payment_method: this.allPaymentMethods.find(p => p.id == salesOrder.payment_method_id),
                };
                this.payment = salesOrder.payment_amount;
                this.order_items = salesOrder.menus.map((menu) => {
                    return {
                        id: menu.id,
                        item_id: menu.item_id,
                        name: menu.items.name,
                        quantity: menu.qty,
                        price: menu.price,
                        subtotal: menu.qty * menu.price,
                        payment_status: 1,
                        note: menu.note,
                        isEdit: false,
                        isPrint: true,
                        discount_price: menu.discount_price || 0,
                        total: 0,
                        createdAt: menu.createdAt,
                        status: menu.status,
                    };
                });
            }
        },
    }
}
</script>